import { isString, isDate, isNumber, isBoolean } from "lodash";
import { SORTING } from "../constants/sorting";

const genericComparator = (a, b) => {
	if (a < b) {
		return -1;
	} else if (a > b) {
		return 1;
	}

	return 0;
};

export const OrderingComparators = {
	[SORTING.TYPES.STRING]: (a, b) =>
		genericComparator(a.toLowerCase(), b.toLowerCase()),
	[SORTING.TYPES.DATE]: (a, b) => genericComparator(a, b),
	[SORTING.TYPES.NUMBER]: (a, b) => genericComparator(a, b),
	[SORTING.TYPES.BOOLEAN]: (a, b) => genericComparator(a, b),
	[SORTING.TYPES.ANY]: () => 0
};

export const getSortingType = value => {
	if (isString(value)) {
		return SORTING.TYPES.STRING;
	}
	if (isDate(value)) {
		return SORTING.TYPES.DATE;
	}
	if (isNumber(value)) {
		return SORTING.TYPES.NUMBER;
	}
	if (isBoolean(value)) {
		return SORTING.TYPES.BOOLEAN;
	}

	return SORTING.TYPES.ANY;
};

const getColumnSortingType = data => {
	if (data.length === 0) {
		return SORTING.TYPES.ANY;
	}

	const [element] = data;

	const result = getSortingType(element);

	for (let i = 1; i < data.length; i++) {
		const newSortingType = getSortingType(data[i]);

		if (newSortingType !== result) {
			return SORTING.TYPES.ANY;
		}
	}

	return result;
};

const getArrayByDirection = (array, direction) => {
	return direction === SORTING.DIRECTIONS.DESC ? array.reverse() : array;
};

export const orderTableColumn = (
	data,
	column,
	direction,
	customComparator = null
) => {
	const dataCopy = [...data];

	if (customComparator) {
		const res = dataCopy.sort(customComparator);
		return getArrayByDirection(res, direction);
	}

	const columnData = dataCopy.map(row => row[column]);
	const sortingType = getColumnSortingType(columnData);

	if (sortingType === SORTING.TYPES.ANY) {
		return dataCopy;
	}

	try {
		const res = dataCopy.sort((a, b) =>
			OrderingComparators[sortingType](a[column], b[column])
		);

		return getArrayByDirection(res, direction);
	} catch (e) {
		return data;
	}
};
